import { render, staticRenderFns } from "./UploadPDF.vue?vue&type=template&id=351c569e&"
import script from "./UploadPDF.vue?vue&type=script&lang=js&"
export * from "./UploadPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports